export namespace StartNewOrder {
  export class UserOrderInfo {
    constructor(
      public orderNumber: number,
      public pickupTime: string,
      public pickupDateTimeUtc: string,
      public status: number,
      public statusDateTimeUtc: string,
      public statusDateTime: string,
      public location: Location,
      public id: string,
      public locationId: number,
      public pickupType: number,
      public isFavorite: boolean,
      public favoriteName: string,
      public sort: number,
      public createDateTimeUtc: string,
      public recipes: Array<MealRecipe>,
      public concurrencyStamp: string,
      // Custom property Image url name based on pickup type
      public pickupImage: string
    ) {}
  }

  export class Location {
    constructor(
      public id: string,
      public address1: string,
      public address2: string,
      public city: string,
      public state: string,
      public zip: string,
      public phone: string,
      public locationName: string,
      public nickName: string,
      public longitude: number,
      public latitude: number,
      public capabilities: Array<string>,
      public unit: number,
      public distance: number,
      public duration: string,
      public timeZone: string,
      public schedules: Array<Schedule>,
      public region: number,
      public isFavorite: boolean,
      public taxPercentage: number,
      public poStype: string,
      public posMetadata: object
    ) {}
  }

  export class MealRecipe {
    constructor(
      public clientId: string,
      public categoryId: number,
      public recipeId: number,
      public customName: string,
      public quantity: number,
      public useReward: boolean,
      public offerId: number,
      public useWhatASize: boolean,
      public isOfferAdded: boolean | false,
      public customizations: Array<MealRecipeCustomization>
    ) {}
  }

  export class Schedule {
    constructor(
      public id: number,
      public serviceArea: number,
      public scheduleType: number,
      public effectiveDate: string,
      public days: Array<ScheduleDay>,
      public reason: string
    ) {}
  }

  export class MealRecipeCustomization {
    constructor(
      public modifierGroupId: number,
      public modifierId: number,
      public specialInstructionIds: Array<number>
    ) {}
  }

  export class ScheduleDay {
    constructor(
      public days: number,
      public openTime: string,
      public closeTime: string
    ) {}
  }
}
